import { uniq } from 'lodash-es';

export default {
  namespaced: true,
  getters: {
    getItems: (_state, _getters, rootState, rootGetters) => (rootGetters['nodes/getItems'] || [])
      .map((node) => {
        const targets = rootGetters['iscsi/targetGroups/getAllTargets'].filter(t => t.node_id === node.id);
        const targetGroups = uniq(targets.map(t => t.targetGroup));
        const tpgs = rootGetters['iscsi/targetGroups/getAllPath'].filter(tpg => tpg && tpg.node_id === node.id);
        const activePaths = tpgs.filter(tpg => tpg.isActive);

        return {
          id: node.id,
          name: node.name,
          status: node.status,
          statusIcon: node.statusIcon,
          statusText: node.statusText,
          targets,
          targetsCount: targets.length,
          targetGroups,
          targetGroupsCount: targetGroups.length,
          tpgs,
          activePathsCount: activePaths.length,
          isDeletable: targetGroups.length > 0
        };
      })
      .filter(node => node.targetGroupsCount > 0),
    getItemById: (_state, _getters) => id => _getters.getItems.find(item => item.id === id)
  }
};
